import React, { useState } from "react";
import { useHistory } from "react-router";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MenuIcon from "@material-ui/icons/Menu";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import { Link } from "react-router-dom";
import { Link as MLink } from "@material-ui/core";

const Hamberger = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [toggle, setToggler] = useState(true);
  const history = useHistory();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleAccountClick = () => {
    setToggler(!toggle);
    toggle ? history.push("/social") : history.push("/portfolio");
  };
  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div>
        <AccountCircleIcon fontSize="large" onClick={handleAccountClick} />
      </div>
      <MenuIcon
        onClick={handleClick}
        style={{ padding: 10 }}
        color="secondary"
        fontSize="large"
      />

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose}>
          <Link to="/portfolio">Home</Link>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Link to="/about">About</Link>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <MLink
            style={{ textDecoration: "underline" }}
            href="https://drive.google.com/file/d/1RHTwdkJT2U8mHhJ9rOYMXOjBvUriapQc/view?usp=sharing"
          >
            Resume
          </MLink>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Link to="/project">Project</Link>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Link to="/contact">Contact</Link>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Link to="/social">Social</Link>
        </MenuItem>
      </Menu>
    </div>
  );
};

export default Hamberger;
